import type { AppIndexEntry } from "playground/apps/index/app-index";
import { projectAppRegistry } from "playground/apps/index/registry";
import { parseAppId } from "playground/apps/playground-json";
import { invariant } from "ts-invariant";

export function jigRouteParams(id: string | undefined) {
  invariant(id, "A jig URL requires an App identity");
  const parsed = parseAppId(id);
  invariant(parsed, `Invalid App identity: ${id}`);
  return { scope: parsed.publisher, appId: parsed.name };
}

export function resolveJig(
  entries: AppIndexEntry[],
  scope: string,
  appId: string,
) {
  return projectAppRegistry(entries).byId.get(`@${scope}/${appId}`);
}
